<template>
  <div class="page-shell page-shell--product-manage">
    <section class="page-shell__content">
      <div class="page-shell__grid">
        <div
          v-loading="classLoading"
          class="page-shell__panel page-shell__tree"
        >
          <div class="page-shell__panel-header">
            <div>
              <div class="page-shell__panel-title">应用分类</div>
              <div class="page-shell__panel-subtitle">
                通过分类树过滤商品列表，并维护分类层级。
              </div>
            </div>
            <el-button
              class="admin-list-tree-add"
              type="text"
              size="mini"
              @click="() => addChildClass()"
            >
              <i class="el-icon-circle-plus-outline" />
            </el-button>
          </div>
          <el-tree
            :data="classTree"
            show-checkbox
            node-key="id"
            ref="classtree"
            default-expand-all
            :expand-on-click-node="false"
            @check-change="checkClassTree"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.appClassificationName }}</span>
              <el-dropdown trigger="click" @command="classHandleClick">
                <span class="el-dropdown-link">
                  <i
                    class="el-icon-arrow-down el-icon--right"
                    @click="classDropdownClick(data)"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="checkNode(node)"
                    command="add"
                    >添加下级分类</el-dropdown-item
                  >
                  <el-dropdown-item command="modify">修改</el-dropdown-item>
                  <el-dropdown-item command="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </el-tree>
        </div>

        <div class="page-shell__panel">
          <div class="page-shell__panel-header">
            <div>
              <div class="page-shell__panel-title">商品列表</div>
              <div class="page-shell__panel-subtitle">
                结合名称、状态和组织快速定位商品。
              </div>
            </div>
          </div>
          <public-table
            v-loading="Loading"
            :column="column"
            :tableData="tableData"
            :onAdd="() => (showCreateProduct = true)"
            addText="创建商品"
            :enableSearch="true"
            :searchItems="searchItems"
            :PageInfo="listQuery"
            @handlePaginationChange="handleSearchList"
          >
            <template v-slot:name="{ row }">
              <el-button
                class="admin-list-primary-link"
                size="mini"
                type="text"
                @click="toProductDetailPage(row)"
                >{{ row.name }}</el-button
              >
            </template>
            <template v-slot:categoryName="{ row }">
              <el-tag
                v-if="row.categoryName"
                class="admin-list-chip"
                size="small"
                type="info"
              >
                {{ row.categoryName }}
              </el-tag>
              <span v-else style="color: #999">-</span>
            </template>
            <template v-slot:status="{ row }">
              <span
                v-if="row.status == 'online'"
                class="admin-list-status admin-list-status--online"
              >
                已上架
              </span>
              <span
                v-if="row.status == 'offline'"
                class="admin-list-status admin-list-status--offline"
                >已下架</span
              >
            </template>
            <template v-slot:realName="{ row }">
              {{ row.realName || '-' }}
            </template>
            <template v-slot:packageCount="{ row }">
              <el-button
                class="admin-list-secondary-link"
                size="mini"
                type="text"
                @click="toProductPackagePage(row)"
              >
                {{ row.packageCount || 0 }}
              </el-button>
            </template>
            <template v-slot:createTime="{ row }">
              {{ row.createTime ? timetrans(row.createTime) : '-' }}
            </template>
            <template v-slot:operation="{ row }">
              <el-button
                class="admin-list-action"
                size="mini"
                type="text"
                @click="toProductDetailPage(row)"
                >管理</el-button
              >
              <el-button
                class="admin-list-action"
                size="mini"
                type="text"
                @click="handleToggleStatus(row)"
              >
                {{ row.status == 'online' ? '下架' : '上架' }}
              </el-button>
              <el-button
                class="admin-list-action admin-list-action--danger"
                size="mini"
                type="text"
                @click="handleDelete(row)"
                >删除</el-button
              >
            </template>
          </public-table>
        </div>
      </div>
    </section>

    <CreateProduct
      v-if="showCreateProduct"
      :marketID="marketID"
      :product="editingProduct"
      :dialogVisible="showCreateProduct"
      :onSuccess="createProductSuccess"
      :onClose="closeCreateProduct"
    ></CreateProduct>
    <CreateOrEditAppClass
      v-if="showClassEdit"
      :marketID="marketID"
      :appClass="appClass"
      :parentAppClass="parentAppClassification"
      :dialogVisible="showClassEdit"
      :onSuccess="createAppClassSuccess"
      :onClose="closeClassEdit"
    ></CreateOrEditAppClass>
  </div>
</template>

<script>
import PublicTable from '@/components/PublicTable/index.vue';
import { havePerm } from '@/utils/auth';
import { timetrans } from '@/utils/validate';
import { errorHandle } from '../../../utils/error';
import CreateProduct from './components/createProduct';
import CreateOrEditAppClass from '../appManage/components/createOrEditAppClass';

const defaultListQuery = {
  page: 1,
  pageSize: 10,
  total: 0,
  query: '',
  status: '',
  categoryID: '',
  organizationID: '',
  classIDs: ''
};

export default {
  name: 'ProductManage',
  data() {
    return {
      havePerm,
      showCreateProduct: false,
      showClassEdit: false,
      editingProduct: null,
      parentAppClassification: {},
      appClass: {},
      timetrans,
      classTree: [],
      classLoading: true,
      curHandleClass: null,
      searchItems: [
        {
          label: '名称',
          name: 'query',
          value: '',
          type: 'input'
        },
        {
          label: '状态',
          name: 'status',
          value: '',
          type: 'select',
          options: [
            {
              label: '全部',
              value: ''
            },
            {
              value: 'online',
              label: '已上架'
            },
            {
              value: 'offline',
              label: '已下架'
            }
          ]
        },
        {
          label: '组织',
          name: 'organizationID',
          value: '',
          type: 'input'
        }
      ],
      column: [
        {
          prop: 'name',
          label: '商品名称',
          scopeStatus: true,
          minWidth: '150'
        },
        {
          prop: 'categoryName',
          label: '应用分类',
          scopeStatus: true,
          width: '150'
        },
        {
          prop: 'status',
          label: '状态',
          width: '70',
          scopeStatus: true
        },
        {
          prop: 'realName',
          label: '创建人',
          scopeStatus: true,
          width: '90'
        },
        {
          prop: 'packageCount',
          label: '套餐',
          scopeStatus: true,
          width: '90'
        },
        {
          prop: 'createTime',
          label: '创建时间',
          scopeStatus: true,
          width: '140'
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true,
          width: '150',
          fixed: 'right'
        }
      ],
      tableData: [],
      listQuery: Object.assign({}, defaultListQuery),
      Loading: false
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    categoryList() {
      return this.$store.state.product.categoryList || [];
    }
  },
  components: {
    PublicTable,
    CreateProduct,
    CreateOrEditAppClass
  },
  created() {
    this.fetchCategoryList();
    this.fetchStoreAppClassList();
    this.fetchProductList();
  },
  methods: {
    fetchCategoryList() {
      // 获取分类列表,用于在商品列表中显示分类名称
      this.$store
        .dispatch('GetCategoryList', {
          marketID: this.marketID,
          disableTree: true
        })
        .catch((err) => {
          console.error('获取分类列表失败:', err);
        });
    },
    handleSearchList(parameter) {
      if (parameter) {
        this.listQuery.page = 1;
        this.listQuery = Object.assign(this.listQuery, parameter);
      } else {
        this.listQuery.page = 1;
      }
      this.fetchProductList();
    },
    fetchProductList() {
      this.Loading = true;
      this.$store
        .dispatch('GetProductList', Object.assign({ marketID: this.marketID }, this.listQuery))
        .then((res) => {
          if (res) {
            // 将分类ID映射为分类名称
            const products = (res.products || []).map(product => {
              const category = this.categoryList.find(cat => cat.appClassificationID === product.categoryID);
              return {
                ...product,
                categoryName: category ? category.appClassificationName : ''
              };
            });
            this.tableData = products;
            this.listQuery.total = res.total || 0;
          }
          this.Loading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    handleDelete(row) {
      this.$confirm('是否要删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch('DeleteProduct', {
            marketID: this.marketID,
            productID: row.productID
          })
          .then((res) => {
            if (res) {
              this.fetchProductList();
              this.$message({
                type: 'success',
                message: '商品删除成功'
              });
            }
          })
          .catch((re) => {
            this.Loading = false;
            errorHandle(re);
          });
      });
    },
    handleToggleStatus(row) {
      const message =
        row.status == 'online' ? '是否要下架该商品?' : '是否要上架该商品?';
      const newStatus = row.status == 'online' ? 'offline' : 'online';
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch('ChangeProductStatus', {
            marketID: this.marketID,
            productID: row.productID,
            status: newStatus
          })
          .then((res) => {
            if (res) {
              this.fetchProductList();
              this.$message({
                type: 'success',
                message: newStatus == 'online' ? '商品上架成功' : '商品下架成功'
              });
            }
          })
          .catch((re) => {
            errorHandle(re);
          });
      });
    },
    toProductDetailPage(row) {
      this.$router.push({
        name: 'StoreProductManageDetails',
        params: { productID: row.productID, tabMode: 'detail' }
      });
    },
    toProductPackagePage(row) {
      this.$router.push({
        name: 'StoreProductManageDetails',
        params: { productID: row.productID, tabMode: 'package' }
      });
    },
    createProductSuccess() {
      this.showCreateProduct = false;
      this.editingProduct = null;
      this.fetchProductList();
    },
    closeCreateProduct() {
      this.showCreateProduct = false;
      this.editingProduct = null;
    },
    // 分类树相关方法
    fetchStoreAppClassList() {
      this.classLoading = true;
      this.$store
        .dispatch('GetStoreAppClassificationList', { marketID: this.marketID })
        .then((res) => {
          if (res) {
            this.classTree = res.tree;
          }
          this.classLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.classLoading = false;
        });
    },
    checkClassTree(data) {
      const nodes = this.$refs.classtree.getCheckedNodes();
      const classIDs = [];
      nodes.map((item) => {
        classIDs.push(item.appClassificationID);
      });
      if (classIDs.join(',') != this.listQuery.classIDs) {
        this.listQuery.classIDs = classIDs.join(',');
        this.listQuery.categoryID = classIDs.join(',');
        this.fetchProductList();
      }
    },
    classHandleClick(cmd) {
      const data = this.curHandleClass;
      if (cmd === 'add') {
        this.addChildClass(data);
      } else if (cmd === 'modify') {
        this.editAppClass(data);
      } else {
        this.removeAppClass(data);
      }
    },
    classDropdownClick(c) {
      this.curHandleClass = c;
    },
    checkNode(node) {
      return node.level <= 1;
    },
    addChildClass(node) {
      if (node) {
        this.parentAppClassification = node;
      }
      this.showClassEdit = true;
    },
    editAppClass(node) {
      this.appClass = node;
      this.showClassEdit = true;
    },
    createAppClassSuccess() {
      this.showClassEdit = false;
      this.fetchStoreAppClassList();
      this.fetchCategoryList();
      this.fetchProductList();
    },
    closeClassEdit() {
      this.parentAppClassification = {};
      this.appClass = {};
      this.showClassEdit = false;
    },
    removeAppClass(node) {
      this.$confirm('删除后该分类下的商品将移除此分类,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store
            .dispatch('DeleteStoreAppClassification', {
              marketID: this.marketID,
              appClassificationID: node.appClassificationID
            })
            .then((res) => {
              this.fetchStoreAppClassList();
              this.fetchCategoryList();
              this.fetchProductList();
            })
            .catch((res) => {
              if (res.code === 10022) {
                this.$message({
                  message: '存在下级分类,不能删除',
                  type: 'warning'
                });
                return;
              }
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';

.el-tree-node > .el-tree-node__children {
  overflow: inherit;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  span {
    line-height: 1.5;
  }

  .el-dropdown-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    color: #7f93a7;
    padding: 4px;
    border-radius: 10px;
    transition: color 0.2s ease, background-color 0.2s ease;

    &:hover {
      color: #3f6f9e;
      background: rgba(232, 240, 248, 0.9);
    }
  }
}

.admin-list-tree-add {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f2f7fb 0%, #e9f0f7 100%);
  color: #416f9a;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.92);

  &:hover,
  &:focus {
    color: #335d85;
    background: linear-gradient(180deg, #e8f0f8 0%, #dee9f3 100%);
  }
}

.admin-list-chip {
  border-color: rgba(178, 197, 214, 0.8) !important;
  background: linear-gradient(180deg, #f8fbfd 0%, #edf3f8 100%) !important;
  color: #586f85 !important;
}

.admin-list-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 76px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.admin-list-status--online {
  background: rgba(33, 162, 107, 0.12);
  color: #1e8f61;
}

.admin-list-status--offline {
  background: rgba(217, 118, 42, 0.12);
  color: #b96d2d;
}

.admin-list-primary-link,
.admin-list-secondary-link,
.admin-list-action {
  padding: 0 !important;
  font-weight: 600;
}

.admin-list-primary-link {
  color: #264d72 !important;
}

.admin-list-secondary-link,
.admin-list-action {
  color: #3f6f9e !important;
}

.admin-list-action--danger {
  color: #c2603c !important;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/productManage/index.vue